import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { DepartmentApiServiceService } from './department-api-service.service';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { Store } from '@ngrx/store';
import { finalize, Observable, take } from 'rxjs';
import { PreventEscCloseDirective } from '../../utils/prevent-esc-close.directive';
import { CommonStaffApiServiceService } from '../personnel/common-staff-api-service.service';
import { PaginationComponent } from "../../components/pagination/pagination.component";
import { ConfomerService } from '../../providers/confomer/confomer.service';
import debounce from 'lodash/debounce';
import { LoaderComponent } from "../../providers/loader.component";
import { FilterBaseAccessService } from '../../auth/filterbase-access';
import { Router } from '@angular/router';

@Component({
  selector: 'app-departments-list',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, FormsModule, CommonModule, PreventEscCloseDirective, PaginationComponent, LoaderComponent],
  templateUrl: './departments-list.component.html',
  styleUrl: './departments-list.component.css'
})
export class DepartmentsListComponent {
  @ViewChild('modalDepartment') modalDepartment!: ElementRef<HTMLDialogElement>;
  Array = Array;
  departmentForm!: FormGroup
  hodList: any[] = [];
  departmentList:any[] = [];
  hodPaginationData: any = {};
  hodCurrentPage: number = 1;
  hodLoadedPages: Set<number> = new Set<number>();

  hodIsFetching: boolean = false;
  hodSearchStr: string = '';
  isreqSending: boolean = false;
  isFetching: boolean = false;
  
  iscreateaccess:boolean=true;
  isviewaccess:boolean=true;
  isdeleteaccess:boolean=true;
  isupdateaccess:boolean=true;
  ischatstudentaccess:boolean=true;
  isperformanceaccess:boolean=true;
  searchStr: string = '';
  paginationData: any = {}
  currentPage: any

  private departmentNameAllowedPattern = /^[A-Za-z0-9 &\-]*$/;

  private trimValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;

  if (value == null || value === '') {
    return null;
  }

  const stringValue = String(value);

  // Reject if value has leading/trailing spaces
  if (stringValue !== stringValue.trim()) {
    return { trim: true };
  }

  // Reject if value contains only spaces
  if (stringValue.trim().length === 0) {
    return { required: true };
  }

  return null;
};

  private departmentNameFormatValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || value === '') return null;
    const str = String(value);

    // If user hasn't typed enough yet, don't show pattern-based error.
    if (str.length < 3) return null;

    if (!this.departmentNameAllowedPattern.test(str)) {
      return { pattern: true };
    }
    return null;
  };

  private departmentNameMinMaxValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || value === '') return null;
    const str = String(value);
    if (str.length < 3) return { minlength: true };
    if (str.length > 100) return { maxlength: true };
    return null;
  };

  constructor(access:FilterBaseAccessService, private fb: FormBuilder, private staffApiService: CommonStaffApiServiceService, private departmentApiService: DepartmentApiServiceService, private toastreService: ToasterService, private store: Store, private conformer: ConfomerService, private router: Router) {
    this.departmentForm = this.fb.group({
      id: [''],
      department_name: ['', [Validators.required, this.trimValidator, this.departmentNameMinMaxValidator, this.departmentNameFormatValidator]],
      user_id: ['', Validators.required],
    });

    this.iscreateaccess=access.checkaccessforfiltersandactions("create");
    this.isviewaccess=access.checkaccessforfiltersandactions("department view");
    this.isdeleteaccess=access.checkaccessforfiltersandactions("department delete");
    this.isupdateaccess=access.checkaccessforfiltersandactions("department update");
    this.ischatstudentaccess=access.checkaccessforfiltersandactions("department chat student");
    this.isperformanceaccess=access.checkaccessforfiltersandactions("department performance")
  

    // Load all HODs (page-by-page) so dropdown shows everything at once.
    this.loadAllHods();
  }
  
  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.isFetching = true;
    this.departmentApiService.getDepartmentList(this.currentPage, this.searchStr)
    .pipe(finalize(() => {
      this.isFetching = false;
    }))
    .subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          const departments = res?.data;
          if (Array.isArray(departments)) {
            this.departmentList = departments;
          } else {
            this.departmentList = [];
          }
          this.paginationData = res?.pagination ?? {};
        }
      },
      error: (err) => {
        console.error('HTTP error:', err);
        this.departmentList = [];
      }
    });
  }

  search = debounce(() => {
    this.getData();
    return;
  }, 500);


  private loadAllHods() {
    // Start fresh and load page-by-page until API returns no more.
    this.hodCurrentPage = 1;
    this.hodList = [];
    this.hodPaginationData = {};
    this.hodLoadedPages = new Set<number>();

    const loadNext = () => {
      // Prevent duplicate calls for the same page.
      if (this.hodLoadedPages.has(this.hodCurrentPage)) return;

      const pageToLoad = this.hodCurrentPage;
      this.hodLoadedPages.add(pageToLoad);
      this.hodIsFetching = true;

      this.staffApiService.getStaffList('HOD', pageToLoad, this.hodSearchStr)
        .pipe(finalize(() => (this.hodIsFetching = false)))
        .subscribe({
          next: (res: any) => {
            if (res.status === 'success') {
              const hods = Array.isArray(res?.data) ? res.data : [];
              this.hodPaginationData = res?.pagination ?? {};
              this.hodList = [...(this.hodList ?? []), ...hods];

              // If API indicates next_page exists and this page returned rows, load the next page.
              const nextPage = res?.pagination?.next_page ?? res?.pagination?.nextPage;
              if (nextPage) {
                this.hodCurrentPage = Number(nextPage);
                loadNext();
              } else if (hods.length > 0) {
                // Fallback: keep incrementing until an empty page is returned.
                this.hodCurrentPage = pageToLoad + 1;
                loadNext();
              }
            }
          },
          error: (err) => {
            console.error('HTTP error:', err);
            this.hodIsFetching = false;
          }
        });
    };

    loadNext();
  }

  getHodList(page: number = 1) {
    // Prevent duplicate requests for the same page in dropdown load-more flow
    if (this.hodLoadedPages.has(page)) return;
    this.hodLoadedPages.add(page);

    // Fresh load (page 1)
    if (page === 1) {
      this.hodList = [];
      this.hodPaginationData = {};
      this.hodLoadedPages = new Set<number>([1]);
    }

    this.hodIsFetching = true;
    this.staffApiService.getStaffList('HOD', page, this.hodSearchStr).pipe(

      finalize(() => {
        this.hodIsFetching = false;
      })
    ).subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          const hods = res?.data ?? [];
          this.hodPaginationData = res?.pagination ?? {};
          if (Array.isArray(hods)) {
            // Keep previous results and append next page for dropdown "load more"
            this.hodList = (page && page > 1 ? [...(this.hodList ?? []), ...hods] : hods);
          } else {
            this.hodList = [];
          }
        }
      },
      error: (err) => {
        console.error('HTTP error:', err);
        this.hodList = [];
      }
    });
  }

  getHodTotalCount(): number {
    return Number(this.hodPaginationData?.total ?? 0) || 0;
  }

  getHodShowingCount(): number {
    const perPage = Number(this.hodPaginationData?.per_page ?? 0) || Number(this.hodPaginationData?.perPage ?? 0) || 0;
    const total = this.getHodTotalCount();
    if (!perPage) return (this.hodList?.length ?? 0);
    return Math.min(total, (Number(this.hodCurrentPage) || 1) * perPage);
  }
  


  


  onSubmitDepartmentForm() {
    if (this.departmentForm.invalid) {
      this.departmentForm.markAllAsTouched();
      this.toastreService.setToaster('error', 'Validation Error', 'Please provide valid department details');
      return;
    }

    const data = { ...this.departmentForm.value };
    this.isreqSending = true;

    const onComplete = () => {
      this.getData();
      this.closeDepartmentModal();
      this.isreqSending = false;
    };

    if (data.id) {
      const id = data.id;
      delete data.id;
      this.departmentApiService.updateDepartment(data, id).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toastreService.setToaster('success', 'Department Updated', res.message || 'Department updated successfully');
          }
          onComplete();
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      });
    } else {
      this.departmentApiService.addDepartment(data).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toastreService.setToaster('success', 'Department Added', res.message || 'Department added successfully');
          }
          onComplete();
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      });
    }
  }


  async deleteDepartment(id: number | string) {
    const confirm = await this.conformer.Open('Confirm Delete', 'Are you sure you want to delete this department?');
    if (confirm) {
      this.departmentApiService.deleteDepartment(id).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toastreService.setToaster('success', 'Success', res.message || 'Department deleted successfully');
            this.getData();
          }
        },
        error: (err: any) => {
          console.error('HTTP error:', err);
        }
      })
    }
  }

  openDepartmentModal(data?: any) {
    this.departmentForm.reset();
    if (data) {
      this.departmentForm.patchValue({
        id: data.id,
        department_name: data.department_name,
        user_id: data.user_id
      });
    }
    this.modalDepartment.nativeElement.showModal();
  }

  closeDepartmentModal() {
    this.departmentForm.reset();
    this.modalDepartment.nativeElement.close();
  }

  pageChange(event: any) {
    this.currentPage = event;
    this.getData();
  }

  openPerformance(id: number | string) {
    this.router.navigate(['/performance', 'department', id]);
  }

  openChat(id: number | string) {
    this.router.navigate(['/chats'], { queryParams: { type: 'department', id } });
  }



}
